import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "../templates/Login";
import ContactUs from "../templates/ContactUs";
import CostCalculator from "../templates/CostCalculator";
import ResetPassword from "../templates/ForgotPassword";
import OfflineHallbarIndex from "../templates/OfflineHallbarIndex";
import OfflineHVIResults from "../templates/OfflineHVIResults";
import Plans from "../templates/Plans";
import OfflineOvi from "../templates/OfflineOvi";
import OfflineOviResults from "../templates/OfflineOviResults";
import SustainMeIndex from "../templates/SustainMeIndex";
import SustainIndex from "../templates/SustainIndex";

const PublicRoutes = () => {
    return (

        <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login/" component={Login} />
            <Route exact path="/contact/" component={ContactUs} />
            <Route exact path="/kostnadskalkylator/" component={CostCalculator} />
            <Route exact path="/reset-password/" component={ResetPassword} />
            <Route exact path="/:company/hvi/" component={OfflineHallbarIndex} />
            <Route exact path="/:company/ovi/" component={OfflineOvi} />
            <Route exact path="/:company/hvi/results" component={OfflineHVIResults} />
            <Route exact path="/:company/ovi/results" component={OfflineOviResults} />
            <Route exact path="/:company/hwi/" component={OfflineHallbarIndex} />
            <Route exact path="/:company/owi/" component={OfflineOvi} />
            <Route exact path="/:company/hwi/results" component={OfflineHVIResults} />
            <Route exact path="/:company/owi/results" component={OfflineOviResults} />
            <Route exact path="/plans/:plan?/:type?/:pstatus?" component={Plans} />
            <Route exact path="/smi/:school/:classroom?/:result_type?" component={SustainMeIndex} />
            <Route exact path="/si/:results?" component={SustainIndex} />
            <Route exact path="/:group/si/:results?" component={SustainIndex} />
            <Route exact path="/wp-content/themes/sustainchangeprod/" element={ <Redirect to="/login/" /> } />
            <Route component={Login} />
        </Switch>

    )
}

export default PublicRoutes;